/* tslint:disable */
/* eslint-disable */
/**
 * DEX API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime'
import {
  PoolTransaction,
  PoolTransactionFromJSON,
  PoolTransactionToJSON,
  TradingTransaction,
  TradingTransactionFromJSON,
  TradingTransactionToJSON,
} from '../models'

/**
 *
 */
export class TransactionsApi extends runtime.BaseAPI {
  /**
   */
  async getFarmingTransactionsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<PoolTransaction>>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/api/private/txns/farming`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PoolTransactionFromJSON))
  }

  /**
   */
  async getFarmingTransactions(initOverrides?: RequestInit): Promise<Array<PoolTransaction>> {
    const response = await this.getFarmingTransactionsRaw(initOverrides)
    return await response.value()
  }

  /**
   */
  async getStakingTransactionsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<PoolTransaction>>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/api/private/txns/staking`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PoolTransactionFromJSON))
  }

  /**
   */
  async getStakingTransactions(initOverrides?: RequestInit): Promise<Array<PoolTransaction>> {
    const response = await this.getStakingTransactionsRaw(initOverrides)
    return await response.value()
  }

  /**
   */
  async getTradingTransactionsRaw(
    initOverrides?: RequestInit,
  ): Promise<runtime.ApiResponse<Array<TradingTransaction>>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/api/private/txns/trading`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TradingTransactionFromJSON))
  }

  /**
   */
  async getTradingTransactions(initOverrides?: RequestInit): Promise<Array<TradingTransaction>> {
    const response = await this.getTradingTransactionsRaw(initOverrides)
    return await response.value()
  }
}
